export default __webpack_public_path__ + "static/telesan_inicio2-b362d0c885031eabf6b2745e81016c40.jpg";